import logoutObserver from '@/observers/LogoutObserver';
import { getNextApiUrl } from '@/utils/next-api';

/**
 * Handles automatic user logout when authentication fails (401 errors)
 * Notifies logout observers and redirects to logout page with autoLogout parameter
 */
export const handleAutoLogout = () => {
  const isSSR: boolean = typeof window === 'undefined';
  logoutObserver.notify({
    data: null,
    onComplete: () => {
      if (!isSSR) {
        // Always add autoLogout parameter to skip the PKCE OpenID account logout process
        const logoutUrl = getNextApiUrl('auth/logout?autoLogout=true');
        window.location.href = logoutUrl;
      }
    },
  });
};
